import { ADVOKIT_URL, PREMIUM_SUPPORT_URL } from "lib/constants";
import { useAuth } from "lib/features/auth";
import { UserRole } from "lib/types";

export const useGetPremiumLink = (): string => {
  const { authUser } = useAuth();

  let premiumLink = PREMIUM_SUPPORT_URL;
  if (authUser?.role !== UserRole.Admin && authUser?.workspace_id === "0") {
    premiumLink = ADVOKIT_URL;
  }

  return premiumLink;
};
